module.exports = __webpack_public_path__ + "img/1572535569.d4415eb3.jpg";